module.exports = __webpack_public_path__ + "img/quanmianyusuan.014808bb.png";